import api, { getBackstageURL } from "services/api";

export interface ViewsCount {
  id: number;
  mhid?: number;
  bodyId: number;
  mhname?: string;
  boardName?: string;
  clickDate?: string;
  fromIp?: string;
}

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    chartViewsCount: build.query<
      ViewsCount[],
      {
        start: string;
        end: string;
      }
    >({
      query: ({ start, end }) => ({
        url: getBackstageURL("/views-count"),
        params: { start, end },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "ViewsCount" as const,
                id,
              })),
              "ViewsCount",
            ]
          : ["ViewsCount"],
    }),
  }),
  overrideExisting: false,
});

export const { useChartViewsCountQuery } = extendedApi;
